var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2298_3172)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 28,
    fill: "#0014cb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8789 33.2346C19.8789 26.7955 25.0988 21.5757 31.5378 21.5757H39.1854C45.8611 21.5757 51.2728 26.9874 51.2728 33.6631C51.2728 40.0521 45.994 45.178 39.6077 44.9902L36.8486 44.909C35.8562 48.3826 32.5911 50.7062 28.9841 50.5058L27.5153 50.4242L28.5093 49.6786C30.0459 48.5262 31.0618 46.8105 31.3335 44.909C25.077 45.1407 19.8789 40.1316 19.8789 33.8709V33.2346Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.183 35.5928C33.183 35.1516 33.3272 34.7867 33.6157 34.4982C33.9042 34.1928 34.269 34.0401 34.7102 34.0401C35.406 34.0401 36.0339 33.9382 36.5939 33.7346C37.1539 33.514 37.5951 33.1661 37.9175 32.691C38.2569 32.2158 38.4266 31.5879 38.4266 30.8073C38.4266 30.2304 38.2823 29.7213 37.9939 29.28C37.7223 28.8388 37.3405 28.491 36.8484 28.2364C36.3733 27.9819 35.8302 27.8546 35.2193 27.8546C34.7442 27.8546 34.2945 27.9394 33.8702 28.1091C33.463 28.2788 33.0896 28.5079 32.7502 28.7964C32.4787 29.034 32.1478 29.2122 31.7575 29.331C31.3842 29.4328 31.0023 29.3394 30.612 29.051C30.2048 28.7455 29.9842 28.3807 29.9502 27.9564C29.9163 27.5322 30.0775 27.1419 30.4339 26.7855C31.0448 26.1576 31.7575 25.674 32.572 25.3346C33.4036 24.9782 34.286 24.8 35.2193 24.8C36.3902 24.8 37.4423 25.0716 38.3757 25.6146C39.326 26.1407 40.0811 26.8534 40.6411 27.7528C41.2011 28.6522 41.4811 29.6704 41.4811 30.8073C41.4811 31.6558 41.3539 32.411 41.0993 33.0728C40.8448 33.7176 40.4799 34.2776 40.0048 34.7528C39.5466 35.211 39.0036 35.5843 38.3757 35.8728C37.7648 36.1443 37.0945 36.3394 36.3648 36.4582C36.3308 36.4752 36.2969 36.4922 36.263 36.5091C36.246 36.5261 36.2375 36.5516 36.2375 36.5855V37.5273C36.2375 37.9685 36.0933 38.3419 35.8048 38.6473C35.5163 38.9358 35.1514 39.08 34.7102 39.08C34.269 39.08 33.9042 38.9358 33.6157 38.6473C33.3272 38.3419 33.183 37.9685 33.183 37.5273V35.5928ZM34.583 43.6364C34.0908 43.6364 33.709 43.5091 33.4375 43.2546C33.183 42.9831 33.0557 42.6013 33.0557 42.1091V41.6764C33.0557 41.1843 33.183 40.811 33.4375 40.5564C33.709 40.2849 34.0908 40.1491 34.583 40.1491H34.9139C35.406 40.1491 35.7793 40.2849 36.0339 40.5564C36.3054 40.811 36.4411 41.1843 36.4411 41.6764V42.1091C36.4411 42.6013 36.3054 42.9831 36.0339 43.2546C35.7793 43.5091 35.406 43.6364 34.9139 43.6364H34.583Z",
    fill: "#0014cb"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2298_3172",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2298_3172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2298_3172",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat_icon.587354cab8af91dd10d2d482673c0de2.svg";
export { ForwardRef as ReactComponent };